import type { ShiptoDepositCrud } from '@diamond/shared/schema/shipto-deposit';
import { buyerCurrencyFormatter } from '@diamond/shared/utils';

export type NlbMovementType =
  ShiptoDepositCrud['getTransactionHistories']['response']['data'][number]['movement_type'];

export type NlbMovementDisplay = {
  sign: '+' | '-';
  formattedAmount: string;
  colorScheme: 'blue' | 'red';
};

export function mapMovementToDisplay(
  movementType: NlbMovementType,
  amount: number,
  formatCurrency: (value: number) => string = buyerCurrencyFormatter
): NlbMovementDisplay {
  if (movementType === 'credit_shipto') {
    return {
      sign: '+',
      formattedAmount: `+${formatCurrency(amount)}`,
      colorScheme: 'blue',
    };
  }

  return {
    sign: '-',
    formattedAmount: `−${formatCurrency(amount)}`,
    colorScheme: 'red',
  };
}
